import { Component } from 'react';
import ProgressBar from './ProgressBar';
import Loader from './Loader';
import './Form.scss';
import languages from '../languages';
import LanguageDetector from './LanguageDetector';
import Tooltip from './Tooltip';

class Form extends Component {
	constructor(props) {
		super(props);
		this.state = {
			working: false,
			workingMessage: '',
			titleLimit: 60,
			minTitleLength: 35,
		}
		this.handleFetchClick = this.handleFetchClick.bind(this);
		this.handleFixTitleClick = this.handleFixTitleClick.bind(this);
		this.handleFixDescrClick = this.handleFixDescrClick.bind(this);
		this.changeLanguage = this.changeLanguage.bind(this);
	}

	handleFetchClick(event) {
		event.preventDefault();
		if (this.props.url) {
			this.fetchPageData();
		}
	}

	async handleFixTitleClick(event) {
		event.preventDefault();
		const {isPro, isLimitUsed, url} = this.props;
		if (!isPro) {
			alert('This feature is available in Advanced plan');
			return;
		}
		if (isLimitUsed) {
			alert('You have reached the usage limit. Subscribe to a higher plan for higher or no limits');
			return;
		}
		if (url) {
			if (!this.props.title) {
				this.setState({
					working: 'title',
					workingMessage: 'Fetching page data...',
				});
				let fetched = await this.fetchPageData();
				this.setState({
					working: false,
					workingMessage: '',
				});
			}
			this.fixData({
				url: url,
				title: this.props.title,
				keywords: this.props.keywords,
				brand: this.props.brand,
				lang: this.props.language,
			})
		} else {
			alert('No page URL provided')
		}
	}

	async handleFixDescrClick(event) {
		event.preventDefault();
		const {isPro, isLimitUsed, url} = this.props;
		if (!isPro) {
			alert('This feature is available in Advanced plan');
			return;
		}
		if (isLimitUsed) {
			alert('You have reached the usage limit. Subscribe to a higher plan for higher or no limits');
			return;
		}
		if (url) {
			if (!this.props.descr) {
				this.setState({
					working: 'descr',
					workingMessage: 'Fetching page data...',
				});
				let fetched = await this.fetchPageData();
				this.setState({
					working: false,
					workingMessage: '',
				});
			}
			this.fixData({
				url: url,
				descr: this.props.descr,
				keywords: this.props.keywords,
				brand: this.props.brand,
				lang: this.props.language,
			})
		} else {
			alert('No page URL provided')
		}
	}

	handleLanguageChange(event) {
		this.changeLanguage(event.target.value);
	}

	handleBrandChange(event) {
		this.props.changeCallback('brand', event.target.value);
		window.localStorage.setItem('snippet-preview-language', event.target.value);
	}

	render() {
		const {isPro} = this.props;

		const fixTitle = this.state.working === 'title'
			? <Loader message={this.state.workingMessage} />
			: isPro
				? (<p className="buttons"><button className="button primary" onClick={this.handleFixTitleClick}>Fix using AI and best SEO practices</button></p>)
				: (<p className="buttons"><button className="button primary has-tooltip" onClick={this.handleFixTitleClick}>Fix using AI and best SEO practices<Tooltip text="Available in Advanced plan" /></button></p>);

		const fixDescr = this.state.working === 'descr'
			? <Loader message={this.state.workingMessage} />
			: isPro
				? <p className="buttons"><button className="button primary" onClick={this.handleFixDescrClick}>Fix using AI and best SEO practices</button></p>
				: <p className="buttons"><button className="button primary has-tooltip" onClick={this.handleFixDescrClick}>Fix using AI and best SEO practices<Tooltip text="Available in Advanced plan" /></button></p>

		return (
			<form className="serp-form">
				<div className="form-field">
					<label htmlFor="url">URL</label>
					<input type="url" id="url" value={this.props.url} onChange={event => this.props.changeCallback('url', event.target.value)} />
					<p className="buttons">
					<button className="button primary" onClick={this.handleFetchClick}>Fetch data</button>
					<LanguageDetector
						url={this.props.url}
						callback={this.changeLanguage}
						updateLimitUsage={this.props.updateLimitUsage}
						isLimitUsed={this.props.isLimitUsed}
						langDetection={this.props.langDetection}
					/>
					</p>
				</div>
				<div className="form-field">
					<label htmlFor="language">Language of your page</label>
					<select name="language" id="language" data-option="language" value={this.props.language} onChange={event => this.props.changeCallback('language', event.target.value)}>{this.prepareLangOptions()}</select>
				</div>
				<div className="form-field">
					<label htmlFor="title">Title</label>
					<ProgressBar text={this.props.title} maxLength="600" minTextLength="30" maxTextLength={this.state.titleLimit} optimalMinTextLength="35" sampleFontSize="20" />
					<textarea rows="2" type="text" id="title" value={this.props.title} onChange={event => this.props.changeCallback('title', event.target.value)} />
					{fixTitle}
				</div>
				<div className="form-field">
					<label htmlFor="descr">Description</label>
					<ProgressBar text={this.props.descr} maxLength="960" minTextLength="70" maxTextLength="158" optimalMinTextLength="130" sampleFontSize="14" labelPrefix="Desktop: " />
					<textarea rows="3" id="descr" value={this.props.descr} onChange={event => this.props.changeCallback('descr', event.target.value)} />
					{fixDescr}
				</div>
				<div className="form-field">
					<label htmlFor="keywords">Keywords</label>
					<input type="text" id="keywords" value={this.props.keywords} onChange={event => this.props.changeCallback('keywords', event.target.value)} />
				</div>
				<div className="form-field">
					<label htmlFor="brand">Brand</label>
					<input type="text" id="brand" value={this.props.brand} onChange={event => this.props.changeCallback('brand', event.target.value)} />
				</div>
				<div className="form-field checkbox">
					<input type="checkbox" id="rating" value="1" onChange={event => this.props.changeCallback('rating', !this.props.rating)} />
					<label htmlFor="rating">Rating</label>

					<input type="checkbox" id="date" value="1" onChange={event => this.props.changeCallback('date', !this.props.date)} />
					<label htmlFor="date">Date</label>
				</div>
			</form>
		);
	}

	changeLanguage(language) {
		console.log('language', language);
		this.props.changeCallback('language', language);
		window.localStorage.setItem('snippet-preview-language', language);
	}

	async fixData(data) {
		if (typeof data.title !== 'undefined') {
			this.setState({
				working: 'title',
				workingMessage: 'Talking to robots, this may take a while...',
			});
			await this.fixTitle(data.title, data.brand, data.lang, data.url, data.keywords);
		}
		if (typeof data.descr !== 'undefined') {
			this.setState({
				working: 'descr',
				workingMessage: 'Talking to robots, this may take a while...',
			});
			await this.fixDescription(data.descr, data.lang, data.url, data.keywords, data.brand);
		}
		this.setState({
			working: false,
			workingMessage: '',
		});
	}

	fetchPageData () {
		const formData = new FormData();
		formData.append('pageUrl', this.props.url);

		return new Promise((resolve) => {
			fetch('/tools/api/get-page-html.php', {
				method: 'POST',
				cache: 'no-cache',
				body: formData
			})
			.then((response) => {
				if (response.status < 400) {
					return response.json()
				} else {
					alert('Cannot connect to ' + formData.pageUrl);
					resolve(false);
				}
			})
			.then((respData) => {
				let {markup} = respData;
				markup = markup.replace(/<img[^>]*>/g,"");
				markup = markup.replace(/<link[^>]*>/g,"");
				markup = markup.replace(/<script[^>]*>/g,"");

				let start = markup.indexOf('<head');
				let end = markup.indexOf('</head') + 6;
				const el = document.createElement('div');
				el.innerHTML = respData.markup.substring(start, end);
				const titleEl = el.querySelector('title');
				let title = titleEl ? titleEl.textContent : '';
				const descrEl = el.querySelector('meta[name="description"]');
				let descr = descrEl ? descrEl.getAttribute('content') : '';

				if (title) {
					this.props.changeCallback('title', title);
				}
				if (descr) {
					this.props.changeCallback('descr', descr);
				}
				resolve(true);
			});
		});
	}

	fixTitle(title, brand = '', lang, url = '', keyword = '') {
		return new Promise((resolve) => {
			const data = new FormData();
			data.append('title', title);
			data.append('brand', brand);
			data.append('keyword', keyword);
			data.append('lang', lang);
			data.append('url', url);

			fetch('ajax/fix-title.php', {
				method: 'POST',
				cache: 'no-cache',
				body: data
			})
			.then((response) => response.json())
			.then((data) => {
				this.props.updateLimitUsage('snippet-preview');
				if (data.status === 'ok') {
					this.props.changeCallback('title', data.title);
					resolve(data.title);
				} else {
					console.error(data.status, data.message);
					resolve('');
				}
			})
			.catch((error) => {
				console.error(error);
				resolve('');
			})
		})
	}

	fixDescription(descr, lang, url = '', keyword = '', brand = '') {
		return new Promise((resolve) => {
			const data = new FormData();
			data.append('descr', descr);
			data.append('brand', brand);
			data.append('keyword', keyword);
			data.append('lang', lang);
			data.append('url', url);

			fetch('ajax/fix-description.php', {
				method: 'POST',
				cache: 'no-cache',
				body: data
			})
			.then((response) => response.json())
			.then((data) => {
				this.props.updateLimitUsage('snippet-preview');
				if (data.status === 'ok') {
					this.props.changeCallback('descr', data.text);
					resolve(data.text);
				} else {
					console.error(data.status, data.message);
					resolve('');
				}
			})
			.catch((error) => {
				console.error(error);
				resolve('');
			})
		})
	}

	prepareLangOptions() {
		const langOptions = languages.map((lang, index) => {
			let key = 'lang-' + index;
			return (
				<option value={lang.name} key={key}>{lang.name}</option>
			);
		});
		return (<>
		<option value=''>Select</option>
		{langOptions}
		</>);
	}
}

export default Form;